import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Modal.scss';

// TODO: continue to add functinality to make this a full modal, not just a modal body.
class Modal extends Component {
  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    hideModal: PropTypes.func,
    open: PropTypes.bool
  };

  componentDidMount() {
    document.addEventListener('keydown', e => this.closeModal(e));
  }

  UNSAFE_componentWillUnmount() {
    document.removeEventListener('keydown', e => this.closeModal(e));
  }

  closeModal = e => {
    const { actions, history } = this.props;
    if (e.target.id === 'modal') {
      e.preventDefault();
      if (history) history.goBack();
      actions.hideModal();
    }
  };

  onClose = () => {
    const { actions, history } = this.props;
    actions.hideModal();
    if (history) history.goBack();
  };

  render() {
    const { children } = this.props;
    const { open } = this.props.modal;
    const { className, hideClose } = this.props.modal.modalProps;
    const toggledClass = open ? 'modal__open' : 'modal';

    return (
      <div id="modal" className={toggledClass} onClick={this.closeModal}>
        <div className={`${className}`}>
          {!hideClose && (
            <span className="modal__close" onClick={this.onClose}>
              &times;
            </span>
          )}
          {children}
        </div>
      </div>
    );
  }
}

export default Modal;
